var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"l-main l-error"},[_c('div',{staticClass:"l-error__inner"},[_c('div',{staticClass:"l-error__message l-error__message--mb"},[_c('span',[_c('img',{attrs:{"src":"/contents/img/station_logo.gif"}})]),_c('h1',[_vm._v(" ただいまメンテナンス中です。 ")]),_c('p',[_vm._v(" ご迷惑をおかけいたしますが、 "),_c('br'),_vm._v(" メンテナンス終了までしばらくお待ち下さい。 ")])])])])
}]

export { render, staticRenderFns }